module.exports = "/work-site/img/safety.d791a3fc.png";